import { render, staticRenderFns } from "./PrjStorage.vue?vue&type=template&id=22f74f5c&"
import script from "./PrjStorage.vue?vue&type=script&lang=ts&"
export * from "./PrjStorage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports